import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EtablissementService {

  constructor(private http:HttpClient) { }

  fetchetablissment(idville:any){
    
    return this.http.get<any>(`${environment.apiUrl}/Etablissement/${idville}`);
  }

}
